import { render, staticRenderFns } from "./Others.vue?vue&type=template&id=2d5bb103"
import script from "./Others.vue?vue&type=script&lang=js"
export * from "./Others.vue?vue&type=script&lang=js"
import style0 from "./Others.vue?vue&type=style&index=0&id=2d5bb103&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports